import { render, staticRenderFns } from "./ChoixLangue.vue?vue&type=template&id=ed46c526&"
import script from "./ChoixLangue.vue?vue&type=script&lang=js&"
export * from "./ChoixLangue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports